var MobileTV = function() {
    var curr_day = 0;
    var hide_current_day = function() {
        $('#pill_day_' + curr_day).addClass('invisible');
        $('#day_' + curr_day).addClass('invisible');
    };
    var show_day = function(d) {
        $('#pill_day_' + d).removeClass('invisible');
        $('#day_' + d).removeClass('invisible');
    };

    return {
        init: function(ndays) {
            $('#prev_arr').on('click', function(){
                if (curr_day == 1) {
                    $('#prev_arr i').addClass('invisible');
                }
                if (curr_day + 1 == ndays) {
                    $('#next_arr i').removeClass('invisible');
                }

                hide_current_day();
                show_day(--curr_day);
            });

            $('#next_arr').on('click', function(){
                if (curr_day == 0) {
                    $('#prev_arr i').removeClass('invisible');
                }

                hide_current_day();
                show_day(++curr_day);
                if (curr_day + 1 == ndays) {
                    $('#next_arr i').addClass('invisible');
                }
            });
        }
    };
}();
